import React from 'react';
import { Link } from 'react-router-dom';
import './Nav.css';

export default function ProjectHeader({ logoSrc = '/siju-tech-logo.png' }) {
  return (
    <header className="comp-nav project-header">
      <div className="comp-logo">
        <img src={logoSrc} alt="Aurora Tech logo" className="comp-logo-img" />
        <span className="comp-brand">Aurora Tech</span>
      </div>

      <div className="comp-controls">
        <Link to="/" className="btn outline">Home</Link>
      </div>
    </header>
  );
}
